module.exports = __webpack_public_path__ + "media/images/icons/close-7d100caca3ad96e0b3479565fd3d28a8.svg";